import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UnifiedLevelPage from './pages/UnifiedLevelPage';
import TeacherUpdateForm from './pages/TeacherUpdateForm';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import Gradebook from './pages/Gradebook';
import ParentLookup from './pages/ParentLookup';
import ProfilePage from './pages/ProfilePage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AcademicCalendar from './pages/AcademicCalendar';
import TextbooksPage from './pages/TextbooksPage';
import CurriculumPage from './pages/CurriculumPage';
import AuthWrapper from './components/AuthWrapper';
import TranscriptPage from './pages/TranscriptPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes - no authentication required */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/parent" element={<ParentLookup />} />
        <Route path="/update" element={<ProfilePage />} />
        <Route path="/calendar" element={<AcademicCalendar />} />
        <Route path="/textbooks" element={<TextbooksPage />} />
        <Route path="/curriculum" element={<CurriculumPage />} />
        
        {/* Protected routes - require authentication */}
        <Route path="/*" element={
          <AuthWrapper>
            <Routes>
              <Route path="/dashboard" element={<HomePage />} />
              <Route path="/dashboard/admin" element={<AdminPage />} />
              <Route path="/dashboard/transcript" element={<TranscriptPage />} />
              <Route path="/dashboard/transcript/:studentId" element={<TranscriptPage />} />
              <Route path="/level/:levelCode" element={<UnifiedLevelPage />} />
              <Route path="/level/:levelCode/grade" element={<Gradebook />} />
            </Routes>
          </AuthWrapper>
        } />
      </Routes>
    </Router>
  );
}

export default App;
